import React from "react";
import Sidebar from "../Sidebar";
import { useSelector } from "react-redux";
import FFLogo from "../../img/FREEFIT_LOGO_new.png";
import HomePageActive from "../../img/ff_and_active_logo_colored.png";
import HomePageWow from "../../img/ff_and_wow_logo_colored.png";
import HomePageWowSVG from "../../img/svg/ff_and_wow_logo_colored.svg";
import HomePageOvdimBari from "../../img/ovdim_bari_logo_colored.png";
import { isPartnerClalit, isPartnerMehudet, isPartnerOvdimBari } from "../../store/partnerStore";
import "../../App.scss";
import "../../styles/header.scss";

/**
 * HeaderV2
 *
 * @param {object} props
 * @param {string} [props.header]
 * @param {React.ReactNode} [props.leftButton]
 * @param {React.ReactNode} [props.rightButton]
 * @returns {JSX.Element}
 */
const HeaderV2 = ({ header, leftButton, rightButton }) => {
  const isSidebarOpened = useSelector((state) => state.mainSlice.isSidebarOpened);
  const isClalit = useSelector(isPartnerClalit);
  const isMehudet = useSelector(isPartnerMehudet);
  const isOvdimBari = useSelector(isPartnerOvdimBari);

  return (
    <header className={`header header-background`}>
      <section>
        <div className={`content-section ${header ? "content-section-align-bottom" : "content-section-align-center"}`}>
          <div className="header-flex">{leftButton || <div className="empty-icon"></div>}</div>
          <div className="header-flex">
            {header ? (
              <>
                <div className="logo-with-header">
                  <img src={FFLogo} alt="logo" className="ff-logo" />
                  <div className="header-text">{header}</div>
                </div>
              </>
            ) : (
              <img
                src={isClalit ? HomePageActive : isMehudet ? HomePageWowSVG : isOvdimBari ? HomePageOvdimBari : null}
                alt="logo"
                style={isClalit ? { width: "140px" } : isOvdimBari ? { width: "65px" } : {}}
              />
            )}
          </div>
          <div className="header-flex">{rightButton || <div className="empty-icon"></div>}</div>
        </div>
      </section>
      {isSidebarOpened ? <Sidebar /> : ""}
    </header>
  );
};

export default HeaderV2;
